import React from 'react'
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useGetStudentClassesQuery } from '../../hooks/useGetStudentClassesQuery';
import { useGetTeacheIdByUserId } from '../../hooks/useGetTeacheIdByUserId';
import { RootState } from '../../redux/store';
import { useGetAssessmentsQuery, useGetStudentMyAssessmentsQuery } from '../../hooks/useGetAssessmentsQuery';
import { Callout, Flex ,Text} from '@radix-ui/themes';
import { SchoolSchedule } from '../../components/common/SchoolSchedule';
import SelectComponent from '../../components/inputs/Select/SelectComponent';
import { momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { Calendar } from 'react-big-calendar';
import { SchoolCalendar } from '../../components/common/SchoolCalendar';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

export const AssessmentsCalendar = () => {
    const { UserId } = useSelector((state: RootState) => state.login.userData)
    const { data: studentData } = useGetTeacheIdByUserId(UserId, {enabled: !!UserId});
    const {data: studentClasses, isLoading: isLoadingStudentClasses, isError: isErrorStudentClasses} = useGetStudentClassesQuery({PageNumber:1, PageSize:100, IdStudent:studentData?.idStudent }, {enabled: !!studentData?.idStudent})
    const { control, setValue, getValues, formState: { errors }, watch, trigger, reset } = useForm<{idClass:string}>({
      defaultValues:{ idClass:''},
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
  });
  const { data: assessments, status: statusAssessments, isLoading: isLoadingAssessments, isError: isErrorAssessments, refetch: refreshAssessments } = useGetStudentMyAssessmentsQuery({ PageNumber: 1, PageSize: 400, IdClass: getValues('idClass') }, { enabled: !!getValues('idClass') });

  const handleClassChange = (idClass:string)=> {
    setValue('idClass', idClass);
    refreshAssessments();
  }
// const events = assessments?.items.map(assessment => {
//   return {
//     title: `${assessment.type} | ${assessment.subject} | ${assessment.weight}%`, 
//     start: assessment?.date? new Date(assessment?.date):undefined,
//     end:assessment?.date? new Date(assessment?.date):undefined,
//     allDay: false,
//   }
// });

const events = assessments?.items
  .filter(assessment => assessment?.date)
  .map(assessment => ({
    title: `${assessment.type} | ${assessment.subject} | ${assessment.weight}%`,
    start: new Date(assessment?.date!), 
    end: new Date(assessment?.date!), 
    allDay: false,
  }));

  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Text>
            Entre como estudante &nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Text>
        </Callout.Root>

      </Flex>
    );
  }

  return (
    <>
    <Flex direction='column' gap='4'>
              <SelectComponent
                  label="Turma"
                  options={studentClasses?.items.map((sc) => ({
                      value: sc.idClass,
                      label: sc.class ?? ""
                  }))}
                  errors={errors}
                  control={control}
                  itemsError={isErrorStudentClasses}
                  itemsLoading={isLoadingStudentClasses}
                  name={"idClass"}
                  onSelect={handleClassChange}
              />
      <SchoolCalendar events={events}/>
    </Flex>
  </>
  )
}
